/* GB motion: reveal on scroll, TOC scroll-spy, stat count-in, legal nav, payment logos */
(function () {
  if (window.__gbMotion) return; window.__gbMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = ['.gb-hero__copy', '.gb-hero__media', '.gb-usp__item', '.gb-swipe__item', '.gb-cat', '.gb-bento__tile', '.gb-spot', '.gb-rev', '.gb-guide', '.gb-why > *', '.gb-proof > *', '.gb-ship > *', '.gb-b2b > *', '.gb-faq details', '.gb-stat', '.gb-step', '.gb-person', '.gb-point', '.gb-post', '.gb-collage img', '.gb-photoband img', '.gb-short', '.gb-pc', '.gb-h', '.gb-head', '.gb-ctaband', '.gb-callout', '.gb-sister', '.gb-quote', '.gb-prose h2', '.gb-shortcard', '.gb-chan', '.gb-cstat'];
  function tag() {
    if (reduce) return;
    var nodes = document.querySelectorAll(SEL.join(','));
    var groups = new Map();
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return; // already visible: no animation on first paint
      el.setAttribute('data-reveal', '');
      var p = el.parentElement; var arr = groups.get(p) || []; arr.push(el); groups.set(p, arr);
    });
    groups.forEach(function (arr) { arr.forEach(function (el, i) { el.style.setProperty('--i', Math.min(i, 8)); }); });
    if (!('IntersectionObserver' in window)) { nodes.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  function tocText(h) {
    var c = h.cloneNode(true); var n = c.querySelector('.gb-artnum');
    if (n) { n.remove(); return n.textContent.trim() + '. ' + c.textContent.trim(); }
    return (h.textContent || '').trim();
  }
  function toc() {
    var body = document.querySelector('.gb-art__body'); var box = document.querySelector('.gb-toc'); if (!body || !box) return;
    var hs = body.querySelectorAll('h2'); if (hs.length < 2) { box.remove(); return; }
    var ol = box.querySelector('ol'); var links = [];
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1) + '-' + tocText(h).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 40);
      var li = document.createElement('li'); var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = tocText(h); li.appendChild(a); ol.appendChild(li); links.push(a);
      a.addEventListener('click', function (ev) { ev.preventDefault(); h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); history.replaceState(null, '', '#' + h.id); });
    });
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); }); } });
    }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
    hs.forEach(function (h) { spy.observe(h); });
  }
  function legalnav() {
    var p = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.gb-legalnav a[data-h]').forEach(function (a) { if (p.indexOf('/pages/' + a.getAttribute('data-h')) === 0) a.classList.add('is-active'); });
  }
  /* Real payment logos: clone the template (rendered by Liquid in gb-head) into placeholders + footer */
  function payicons() {
    var tpl = document.getElementById('gbPayicons'); if (!tpl) return;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-gb-payicons]:empty'));
    var footer = document.querySelector('.footer-content .payment-icons');
    if (footer && !footer.parentElement.querySelector('.gb-payicons')) { var holder = document.createElement('div'); holder.setAttribute('data-gb-payicons', ''); footer.parentElement.insertBefore(holder, footer); targets.push(holder); }
    targets.forEach(function (t) { t.appendChild(tpl.content.cloneNode(true)); });
  }
  function run() { tag(); toc(); legalnav(); payicons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function () { tag(); payicons(); });
})();
